import { render, staticRenderFns } from "./cadastro.vue?vue&type=template&id=c0c3a6e8&"
import script from "./cadastro.vue?vue&type=script&lang=js&"
export * from "./cadastro.vue?vue&type=script&lang=js&"
import style0 from "./cadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports